import React, { useEffect, useState } from "react";
import { IconButton, List, ListItem, ListItemText, MenuItem, Select } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Input,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Form, useNavigate } from "react-router-dom";
import { DropdownChangeEvent } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { enqueueSnackbar } from "notistack";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { stockTypes } from "../../types/stockTypes";
import { setLoading } from "../../store/CommonSlice";
import { CustomMessage } from "../../const/Spinner";
import { createStockData, getStockByIdData, updateStockData } from "../../api/Services/stockService";
import { getCountryAssetMasterDataList, getLocalStoreByCountryId, getManufacturerAssetMasterDataList, getModelByManufacturerId, getStockCodeById, getStockCodeeById, getSupplierMasterDataList, saveStockCode, saveStockCodee } from "../../api/Services/masterServie";
import { getStockCodeMasterDataList } from "../../api/Services/masterServie";
import LocalStore from "../Masters/LocalStore";
import { getLocalStoreMasterDataList } from "../../api/Services/masterServie";
import { getUnitsMasterDataList } from "../../api/Services/masterServie";
import { CountryMaster, stockAttachments, StockCode, UnitMaster } from "../../types/assetTypes";
import { getCurrencyAssetMasterDataList } from "../../api/Services/masterServie";
import { LocalStoreMaster } from "../../types/assetTypes";
import { CurrencyMaster } from "../../types/assetTypes";
import DownloadIcon from "@mui/icons-material/Download";
import { uploadFiles } from "../../api/Services/assetServices";
import { useRef } from "react";
import Logo from "../../assets/companyLogo.png";
import ReusablePrimeReactDialog from "../../Component/Dialog/ReusablePrimeReactDialog";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import ChooseCam from "@mui/icons-material/Camera";
import "react-html5-camera-photo/build/css/index.css";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import { base64ToFile } from "../../const/const";
import { FILE_DOWNLOAD_PREVIEW, PAGESEND, PAGESTART } from "../../api/endpoint";
import { RootState } from "../../store/Reduxstore";
interface CreateStockCodeProps {
  setStockCodeId: React.Dispatch<React.SetStateAction<number | null>>;
  setOpen: (open: boolean) => void;
  stockCodeId: number | null;

  selectedCountryId: string | null;
  selectedCountryName: string;           // ✅ add this
  selectedLocalStoreId: string | null;
  selectedLocalStoreName: string;        // ✅ add this

  getListOfSelectedProducts: () => void;
}

const CreateStockCode: React.FC<CreateStockCodeProps> = ({
  setStockCodeId,
  setOpen,
  stockCodeId,
  selectedCountryId,
  selectedCountryName,           // ✅ include here
  selectedLocalStoreId,
  selectedLocalStoreName,        // ✅ include here
  getListOfSelectedProducts,
}) => {

  

  const dispatch = useDispatch();
  const userDetails = useSelector((state: RootState) => state.auth)
      console.log(userDetails);

  const [formData, setFormData] = useState<StockCode>({
  stockCodeId: 0,
  
  stockCode: "",
  stock_description: "",
  currentLocationId: null,
  countryName: "",
  localStoreId: null,
   location: "",
  localStore: "",
  insuranceCurrency: "",
  insuranceCurrencyId: 0,
  original_mfg: "",
  model_part_no: "",
  stock_category: "",
  supplierId: null,
  supplierName: "",
  current_stock: 0,
  unitId: null,
  unitName: "",
  qty: 0,
  unit_price: 0,
  total_price: 0,
  manufacturerIds: [],
  modelIDs: [],
  stockAttachments: [],
  date: null,          
});

useEffect(() => {
  setFormData((prev) => ({
    ...prev,
    currentLocationId: selectedCountryId ? Number(selectedCountryId) : null,
    countryName: selectedCountryName ?? "",
    localStoreId: selectedLocalStoreId ? Number(selectedLocalStoreId) : null,
    localStore: selectedLocalStoreName ?? "",
  }));
}, [selectedCountryId, selectedCountryName, selectedLocalStoreId, selectedLocalStoreName]);


  const [countryName, setCountryName] = useState<
  { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (countryName.length === 0) getCountryNamesList(1,PAGESEND);
  }, [countryName]);


  const [insuranceCurrency, setInsuranceCurrency] = useState<
  { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (insuranceCurrency.length === 0) getInsuranceCurrencyList(1,PAGESEND);
  }, [insuranceCurrency]);


    const [unit, setUnits] = useState<
      { label: string; value: string | null }[]
    >([]);

    useEffect(() => {
      if (unit.length === 0) getunitsList(1,PAGESEND);
    }, [unit]);

    const [localStore, setLocalStore] = useState<
      { label: string; value: string | null }[]
    >([]);
    

    const getunitsList = async (page: number, rows: number) => {
      dispatch(setLoading(true));
      try {
        const { data, status } = await getUnitsMasterDataList(page, rows);
        if (status.code === 200 && data?.length > 0) {
          const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
            value: val.unitId.toString(),
            label: val.unitName,
          }));
          updatedData.unshift({ label: "--Select--", value: null });
          setUnits(updatedData);
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };  


   useEffect(() => {
     if (stockCodeId !== null && stockCodeId != 0) {
       getStockCodeById(stockCodeId);
     }
   }, [stockCodeId]);
 

    const getCountryNamesList = async (page: number, rows: number) => {
      dispatch(setLoading(true));
      try {
        const { data, status } = await getCountryAssetMasterDataList(page, rows,{currentLocationId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
            value: val.currentLocationId.toString(),
            label: val.countryName,
          }));
          updatedData.unshift({ label: "--Select--", value: null });
          setCountryName(updatedData);
          
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };  

   
    const getLocalStoreList = async (currentLocationId: number) => {
      dispatch(setLoading(true));
      try {
          const { data, status } = await getLocalStoreByCountryId(currentLocationId);
  
          if (status.code === 200 && data?.localStores?.length > 0) {
              const updatedData: { label: string; value: string | null }[] = data.localStores.map(
                  (val: { localStoreId: number; localStoreName: string }) => ({
                      value: String(val.localStoreId), // Convert to string
                      label: val.localStoreName ?? "", // Ensure it's a string
                  })
              );
              updatedData.unshift({ label: "--Select--", value: null });
              setLocalStore(updatedData);
          } 
      } catch (error: any) {
          CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
          dispatch(setLoading(false));
      }
  };
  

    const getInsuranceCurrencyList = async (page: number, rows: number) => {
      dispatch(setLoading(true));
      try {
        const { data, status } = await getCurrencyAssetMasterDataList(page, rows, {insuranceCurrencyId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: String(val.insuranceCurrencyId), // Convert to string
            label: val.insuranceCurrency ?? "", // Ensure it's a string
          }));
    
          updatedData.unshift({ label: "--Select--", value: "0" }); // Convert 0 to "0"
          setInsuranceCurrency(updatedData);
        }
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };
    
const handleSubmit = async (event: React.FormEvent) => {
  event?.preventDefault();

  if (formData.stockCode === "") {
    CustomMessage("Add the stock code", "error", enqueueSnackbar);
    return;
  }

  dispatch(setLoading(true));

  try {
    // ✅ Sanitize all integer fields
    const cleanedFormData = {
      ...formData,
      currentLocationId: Number(formData.currentLocationId) || 0,
      localStoreId: Number(formData.localStoreId) || 0,
      insuranceCurrencyId: Number(formData.insuranceCurrencyId) || 0,
      supplierId: Number(formData.supplierId) || 0,
      current_stock: Number(formData.current_stock) || 0,
      unitId: Number(formData.unitId) || 0,
      qty: Number(formData.qty) || 0,
      unit_price: Number(formData.unit_price) || 0,
      total_price: Number(formData.total_price) || 0,
      stockCodeId: Number(formData.stockCodeId) || 0,
    };

    const response = await saveStockCodee(cleanedFormData);

    CustomMessage(
      response.status.message,
      "success",
      enqueueSnackbar
    );
    handleClear();
    // getListOfSelectedProducts();
  } finally {
    dispatch(setLoading(false));
  }
};

  
  const handleClear = () => {
    setFormData({
      stockCodeId: 0,

  stockCode: "",
  stock_description: "",
  currentLocationId: null,
  countryName: "",
  localStoreId: null,
  localStore: "",
   manufacturerIds: [],
    insuranceCurrency: "",
  insuranceCurrencyId: 0,
  original_mfg: "",
  model_part_no: "",
  stock_category: "",
  supplierId: null,
  supplierName: "",
  current_stock: 0,
  unitId: null,
  unitName: "",
  qty: 0,
  unit_price: 0,
  total_price: 0,
  modelIDs: [],
  stockAttachments:[],
    location: "",
  date: null,
    });
    setOpen(false); // To close or reset modal if you are using one
  };
  
  const [manufacturer, setManufacturer] = useState<
      { label: string; value: number }[]
    >([]);

  useEffect(() => {
      if (manufacturer.length === 0) getManufacturerList(1,PAGESEND);
    }, [manufacturer]);

    const getManufacturerList = async (page: number, rows: number) => {
    
      try {
        const { data, status } = await getManufacturerAssetMasterDataList(page, rows,{manufacturerId:{value:"",matchMode: "startsWith"}});
        if (status.code === 200 && data?.length > 0) {
          const updatedData = data.map((val) => ({
            value: val.manufacturerId,
            label: val.manufacturerName,
          }));
          updatedData.unshift({ label: "--Select--", value: 0 });
          setManufacturer(updatedData);
        } 
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } 
    };
  
  
  
  // State declaration
     const [models, setModels] = useState<{ label: string; value: number }[]>([{label: "Select a model", value: 0 }]);
         
  
  
 const getModelList = async (manufacturerId: number) => {
  try {
    const { data, status } = await getModelByManufacturerId(manufacturerId);

    if (status.code === 200 && Array.isArray(data) && data.length > 0) {
      const newModels = data.map((val: { modelId: number; modelName: string }) => ({
        label: val.modelName,
        value: val.modelId,
      }));

      // Use functional form of setModels to merge and deduplicate
      setModels((prevModels) => {
        const combined = [...prevModels, ...newModels];

        const uniqueMap = new Map<number, { label: string; value: number }>();
        combined.forEach((model) => {
          if (model.value !== 0) {
            uniqueMap.set(model.value, model);
          }
        });

        return [{ label: "--Select--", value: 0 }, ...Array.from(uniqueMap.values())];
      });

    }
  } catch (error: any) {
    CustomMessage(error?.message, "error", enqueueSnackbar);
  }
};



const handleSelectManufacturerChange = async (
  event: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any
) => {
  const selectedOptions = event.target.value; // array of { label, value }

  const selectedManufacturerIds = selectedOptions.map((option: any) => option.value);

  const updatedData: Partial<StockCode> = {
    ...formData,
    manufacturerIds: selectedManufacturerIds,
    modelIDs: [], // clear selected models
  };

  setFormData(updatedData as StockCode);

  // If no manufacturers selected, clear models
  if (selectedManufacturerIds.length === 0) {
    setModels([{ label: "--Select--", value: 0 }]);
    return;
  }

  // Fetch models for all selected manufacturers and combine
  const allModelData: { label: string; value: number }[] = [];

  for (const id of selectedManufacturerIds) {
    try {
      const { data, status } = await getModelByManufacturerId(id);
      if (status.code === 200 && Array.isArray(data)) {
        const modelsForManufacturer = data.map((val: { modelId: number; modelName: string }) => ({
          label: val.modelName,
          value: val.modelId,
        }));
        allModelData.push(...modelsForManufacturer);
      }
    } catch (err: any) {
      CustomMessage(err?.message, "error", enqueueSnackbar);
    }
  }

  // Deduplicate combined model list
  const uniqueModelsMap = new Map<number, { label: string; value: number }>();
  allModelData.forEach((model) => {
    if (model.value !== 0) {
      uniqueModelsMap.set(model.value, model);
    }
  });

  setModels([{ label: "--Select--", value: 0 }, ...Array.from(uniqueModelsMap.values())]);
};


  

  useEffect(() => {
    if (stockCodeId !== null && stockCodeId != 0) {
      getStockDataById();
    }
  }, [stockCodeId]);

  useEffect(() => {
  if (formData) {
    console.log("Updated formData:", formData);
  }
}, [formData]);


const getStockDataById = async () => {
  if (!stockCodeId) {
    CustomMessage("StockCode not selected", "error", enqueueSnackbar);
    return;
  }

  dispatch(setLoading(true));

  try {
    const response = await getStockCodeeById(stockCodeId);

    // 🔍 Log full response object
    console.log("Full response:", response);

    let { data, status } = response;

    // 🔍 Log only the 'data' part
    console.log("Response data:", data);

    if (status.code === 200 && data) {
      const { manufacturerIds } = data;

      // 🌐 Fetch models for manufacturerIds before setting formData
      if (Array.isArray(manufacturerIds) && manufacturerIds.length > 0) {
        const allModelData: { label: string; value: number }[] = [];

        for (const id of manufacturerIds) {
          try {
            const { data: modelData, status: modelStatus } = await getModelByManufacturerId(id);

            if (modelStatus.code === 200 && Array.isArray(modelData)) {
              const modelsForManufacturer = modelData.map((val: { modelId: number; modelName: string }) => ({
                label: val.modelName,
                value: val.modelId,
              }));

              allModelData.push(...modelsForManufacturer);
            }
          } catch (err: any) {
            CustomMessage(err?.message, "error", enqueueSnackbar);
          }
        }

        // Deduplicate models
        const uniqueModelsMap = new Map<number, { label: string; value: number }>();
        allModelData.forEach((model) => {
          if (model.value !== 0) {
            uniqueModelsMap.set(model.value, model);
          }
        });

        const modelList = [{ label: "--Select--", value: 0 }, ...Array.from(uniqueModelsMap.values())];
        setModels(modelList);
      }

      // ✅ Finally, set the form data
      setFormData(data);
      console.log("✅ Final formData set:", data);
    } else {
      CustomMessage(status.message, "error", enqueueSnackbar);
    }
  } catch (error: any) {
    CustomMessage(error.message, "error", enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};


  const handleChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: string
  ) => {
    const value = e.target ? e.target.value : e.value;
    setFormData((prev) => ({
      ...prev,
      [name]:
        typeof value === "object" && value !== null
          ? value?.value
          : (value ?? ""),
    }));
  };

    const handleSelectUnitsChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> |any
    ) => {
      const updatedData = { ...formData };
    
      if ("value" in e.target) {
        updatedData.unitName = (e.target as { value: { label: string } }).value?.label || "" as string;
        updatedData.unitId = (e.target as any).value?.value || 0;
      }
    
      setFormData(updatedData);
    };  

    const handleSelectStoreChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof LocalStoreMaster,
      name2: keyof LocalStoreMaster
    ) => {
      const updatedData: Partial<StockCode> = { ...formData };
    
      (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
      (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    
      setFormData(updatedData as StockCode);
    };

    const handleSelectCurrencyChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof CurrencyMaster,
      name2: keyof CurrencyMaster
    ) => {
      const updatedData: Partial<StockCode> = { ...formData };
    
      (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
      (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    
      setFormData(updatedData as StockCode);
    };
    
    const handleSelectCountryChange = (
      e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
      name: keyof CountryMaster,
      name2: keyof CountryMaster
    ) => {
      const updatedData: Partial<StockCode> = { ...formData };
    
      (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
      (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;

    
      setFormData(updatedData as StockCode);
      getLocalStoreList((e.target as { value: { value: number } }).value?.value || 0)
      
    };
  
    interface Location {
      latitude: number;
      longitude: number;
    }

    const removeFile = () => {
    const updatedData = { ...formData, stockAttachments: [] };
    setFormData(updatedData);
  };

    const TakeCamera = () => {
      const [location, setLocation] = useState<Location | null>(null);
      const [imgsrc, setImgSrc] = useState<string|null>(null);
      const [cameraOpen, setCameraOpen] = useState(false);
      const [openCam,setOpenCam] = useState(false)
      const streamRef = useRef<MediaStream | null>(null);

      useEffect(() => {
          getLocation();
      }, []);

      const watermark = new Image();
        watermark.crossOrigin = "anonymous";
        watermark.src = Logo;
        watermark.onload = function () {
            const canvas = document.createElement("canvas"); 
            canvas.width = watermark.width; 
            canvas.height = watermark.height; 
            const ctx = canvas.getContext("2d");
            if(ctx){
              ctx.drawImage(watermark, 0, 0);
            }
            const imgData = canvas?.toDataURL("image/png"); 
        };
        watermark.onerror = function () {
            console.error("Failed to load watermark image.");
        };

      interface CapturePhotoProps {
        dataUri: string;
      }

      const capturePhoto = async ({ dataUri }: CapturePhotoProps): Promise<void> => {
        try {
          const img = new Image();

          const loadImage = new Promise<void>((resolve, reject) => {
            img.onload = () => resolve();
            img.onerror = () => reject(new Error("Failed to load image"));
            img.src = dataUri;
          });

          await loadImage;

          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const context = canvas.getContext("2d");

          if (context) {
            context.drawImage(img, 0, 0);

            const timestamp = new Date().toLocaleString();
            const gpsLocation = `${location?.latitude},${location?.longitude}`;

            context.font = "18px Arial";
            context.fillStyle = "white";
            context.fillText(timestamp, 10, 30);
            context.fillText(gpsLocation, 10, 60);

            const logoWidth = 130; // Adjust the logo size as needed
            const logoHeight = 70;
            const logoX = canvas.width - logoWidth - 25; // Adjust the position as needed
            const logoY = canvas.height - logoHeight - 25;
            context.drawImage(watermark, logoX, logoY, logoWidth, logoHeight);
          }
            const photo = canvas.toDataURL();
            setCameraOpen(false);
            setImgSrc(photo);
        } catch (error:any) {
          CustomMessage(`Error capturing photo:${error?.message}`,"error",enqueueSnackbar)
          console.error("Error capturing photo:", error);
        }
      };

      const handleLocation = (position: GeolocationPosition) => {
          setLocation(position.coords);
      };

      const requestCameraAccess = async (video:boolean) => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: video });
            // Use the camera stream as needed
            streamRef.current = stream; // Store the stream reference
        } catch (error:any) {
          console.error("Error accessing camera:", error);
          CustomMessage(`Error accessing camera:${error?.message}`,'error',enqueueSnackbar);
          const tracks = streamRef.current?.getTracks() || [];
          tracks.forEach((track) => track.stop());
        }
      };

      const stopCamera = () => {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(track => track.stop()); // Stop all tracks
          streamRef.current = null; // Clear the reference
        }
        setCameraOpen(false);
        setOpenCam(false);
      };            

      const handleError = (error:any) => {
        CustomMessage(error?.message,'error',enqueueSnackbar);
          console.error(error);
      };

      const getLocation = () => {
          if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(handleLocation, handleError);
          } else {
            CustomMessage("Geolocation is not supported by this browser",'error',enqueueSnackbar);
              console.error("Geolocation is not supported by this browser");
          }
      };

      const openCamera = async () => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ video: true })
            .then(() => {
              try{
                    requestCameraAccess(true);
                  setCameraOpen(true);
                  setOpenCam(true);
                  // setImgSrc(null);
              }catch(error){
                  console.error("Error opening camera:", error);
                  setCameraOpen(false);
                  setOpenCam(false);
              }
            })
            .catch((error:any) => {
            // Handle camera access error
              CustomMessage(`Camera access denied:${error?.message}`,'error',enqueueSnackbar);
                console.error('Camera access denied:', error);
            });
        }
      };

    const uploadImage = async () => {
  if (!imgsrc) {
    CustomMessage("Image not generated", 'error', enqueueSnackbar);
    return;
  }

  // Restrict to one file at a time
  if (formData.stockAttachments && formData.stockAttachments.length > 0) {
    CustomMessage(
      "Only one image can be uploaded at a time. Please remove the existing one before uploading a new image.",
      'warning',
      enqueueSnackbar
    );
    return;
  }

  dispatch(setLoading(true));

  try {
    const file = base64ToFile({ base64: imgsrc, filename: 'Stock.png' });

    const data = new FormData();
    data.append('file', file);

    const response = await uploadFiles(data);

    if (response.status.code === 201) {
      const uploadedAttachment: stockAttachments = {
        stockAttachmentId: response.data.attachmentId, // If your backend returns this
        attachmentId: response.data.attachmentId,
        name: response.data.name,
        savedAttachmentName: response.data.savedAttachmentName,
      };

      setFormData((prev) => ({
        ...prev,
        stockAttachments: [uploadedAttachment],
      }));

      CustomMessage("Image uploaded successfully", 'success', enqueueSnackbar);
      stopCamera();
    } else {
      CustomMessage(`Upload failed with status: ${response.status.code}`, 'error', enqueueSnackbar);
    }
  } catch (error: any) {
    CustomMessage(`Image upload error: ${error.message}`, 'error', enqueueSnackbar);
  } finally {
    dispatch(setLoading(false));
  }
};


      return (
        <div>
          <ReusablePrimeReactDialog
            header="Take Photo"
            visible={openCam}
            onHide={()=>setOpenCam(false)}
            footer={
              <div>
                {!cameraOpen&&
                  <>
                    <ReusablePrimeButton severity="secondary" onClick={stopCamera}>Cancel</ReusablePrimeButton>
                    <ReusablePrimeButton severity="info" onClick={uploadImage}>Upload</ReusablePrimeButton>
                  </>
                }
              </div>
            }
          >
            {
              cameraOpen ?
                  <Camera
                      onTakePhoto={(dataUri: string) => capturePhoto({ dataUri })}
                      idealFacingMode="environment"
                      isFullscreen={false}
                      idealResolution={{ width: 640, height: 480 }}
                      imageType={IMAGE_TYPES.PNG}
                      videoStream={streamRef.current}
                  />
              :
              imgsrc && <img src={imgsrc} alt="logo" />
            }
          </ReusablePrimeReactDialog>
          <Box display="flex" flexDirection="column" alignItems="center">
            {formData.stockAttachments.length === 0 ? (
              <Box
                onClick={openCamera}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: 2,
                  border: "1px dashed gray",
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "300px",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <ChooseCam />
                <span>Take photo</span>
              </Box>
            ) : (
              <ListItem>
                <img
                  src={`${FILE_DOWNLOAD_PREVIEW + formData.stockAttachments[0].attachmentId}`}
                  alt={formData.stockAttachments[0].name}
                  loading="lazy"
                  style={{
                    width: "100%",
                    maxWidth: "200px",
                    height: "auto",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
            <Box display="flex">
              <div>
                <a
                  href={`${FILE_DOWNLOAD_PREVIEW + formData.stockAttachments[0].attachmentId}`}
                  download
                  style={{ textDecoration: "none" }}
                >
                  <IconButton color="info">
                    <DownloadIcon />
                  </IconButton>
                </a>
              </div>
              <div>
                <IconButton edge="end" onClick={removeFile}>
                  <CloseIcon />
                </IconButton>
              </div>
            </Box>
          </ListItem>
  )}
</Box>

        </div>
      );
  };

   const [suppliers, setSuppliers] = useState<
      { label: string; value: string | null }[]
      >([]);

    useEffect(() => {
          if (suppliers.length === 0) getSupplierList(1, PAGESEND);
        }, [suppliers]);

    const getSupplierList = async (page: number, rows: number) => {
      dispatch(setLoading(true));
      try {
        const { data, status } = await getSupplierMasterDataList(
          page,
          rows,
          { supplierId: { value: "", matchMode: "startsWith" } }
        );
    
        if (status.code === 200 && data?.length > 0) {
          const updatedData: { label: string; value: string | null }[] = data.map(
            (val: { supplierId: number | string; supplierName: string }) => ({
              value: String(val.supplierId), // Ensure it's a string
              label: val.supplierName ?? "",          // Ensure it's a string
            })
          );
    
          updatedData.unshift({ label: "--Select--", value: null }); // Accept null here
          setSuppliers(updatedData);
          console.log("Mapped location data:", updatedData);
        }
      } catch (error: any) {
        CustomMessage(error?.message, "error", enqueueSnackbar);
      } finally {
        dispatch(setLoading(false));
      }
    };

      const handleSelectFromSupplierChange = (     
    
        _event: any,
        newValue: { label: string; value: string | null } | null
      ) => {
        if (!newValue || !newValue.value) return;
      
        const updatedData: Partial<StockCode> = { ...formData };
      
        updatedData.supplierName = newValue.label;
        updatedData.supplierId = parseInt(newValue.value);
      
        console.log("info:", updatedData);
      
        setFormData(updatedData as StockCode);
       
        
      };
    
        
    
    

  return (
    <>
      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 3,
          padding: 2, // Add padding for better spacing
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        {/* <Typography
          variant="h4"
          gutterBottom
          sx={{ textAlign: "center", marginBottom: 3 }}
        >
          Stock Details 
        </Typography> */}
        <Grid container spacing={3}>

          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Country</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select a Country"
                id="countryName"
                value={{
                  label: formData.countryName ?? "", 
                  value: formData.currentLocationId?.toString() ?? "", 
                }}
                options={countryName}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  // handleChange({ target: { value: newValue } }, "technique")
                  handleSelectCountryChange({ target: { value: newValue } }, "countryName", "currentLocationId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an country"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Local Store</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select a Local Store"
                id="localStore"
                value={{
                  label: formData.localStore ?? "", 
                  value: formData.localStoreId?.toString() ?? "", 
                }}
                
                
                options={localStore}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  // handleChange({ target: { value: newValue } }, "technique")
                  handleSelectStoreChange({ target: { value: newValue } }, "localStore", "localStoreId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an local store"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <h6>Enter Stock Code</h6>
            <FormControl fullWidth>
              <Input
                id="stockCode"
                
                value={formData.stockCode}
                onChange={(e) => handleChange(e, "stockCode")}
              />
              
            </FormControl>
          </Grid>  

          <Grid item xs={12} sm={6} md={3}>
            <h6>Enter Stock Description</h6>
            <FormControl fullWidth>
              <Input
                id="stock_description"
                
                value={formData.stock_description}
                onChange={(e) => handleChange(e, "stock_description")}
              />
              
            </FormControl>
          </Grid>  

          <Grid item xs={12} sm={6} md={3}>
            <h6>Enter Location</h6>
            <FormControl fullWidth>
              <Input
                id="location"
                
                value={formData.location}
                onChange={(e) => handleChange(e, "location")}
              />
              
            </FormControl>
          </Grid> 

          <Grid item xs={12} sm={6} md={3}>
            <h6>Original MFG</h6>
            <FormControl fullWidth>
              <Input
                id="original_mfg"
                
                value={formData.original_mfg}
                onChange={(e) => handleChange(e, "original_mfg")}
              />
              
            </FormControl>
          </Grid> 

          <Grid item xs={12} sm={6} md={3}>
            <h6>Model/Part No</h6>
            <FormControl fullWidth>
              <Input
                id="model_part_no"
                
                value={formData.model_part_no}
                onChange={(e) => handleChange(e, "model_part_no")}
              />
              
            </FormControl>
          </Grid> 

          <Grid item xs={12} sm={6} md={3}>
            <h6>Stock Category</h6>
            <FormControl fullWidth>
              <Autocomplete
                id="stock_category"
                options={[
                  { label: "Electrical", value: "electrical" },
                  { label: "Rubber", value: "rubber" },
                ]}
                getOptionLabel={(option) => option.label}
                value={
                  [
                    { label: "Electrical", value: "electrical" },
                    { label: "Rubber", value: "rubber" },
                  ].find((opt) => opt.value === formData.stock_category) || null
                }
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    stock_category: newValue ? newValue.value : "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select category"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Select Manufacturers</h6>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                id="manufacturer"
                options={manufacturer} // array of { label, value }
                getOptionLabel={(option) => option.label}
                value={manufacturer.filter((option) =>
                  formData.manufacturerIds.includes(option.value)
                )}
                onChange={(event, newValue) => {
                  // Manually create a mock event object to reuse the handler
                  const mockEvent = {
                    target: {
                      value: newValue, // same format expected by your handler
                    },
                  };
                  handleSelectManufacturerChange(mockEvent);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select one or more manufacturers"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />
            </FormControl>
          </Grid>


          {/* <Grid item xs={12} sm={6} md={3}>
            <h6>Select Manufacturers</h6>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                id="manufacturer"
                options={manufacturer} // array of { label, value }
                getOptionLabel={(option) => option.label}
                value={manufacturer.filter((option) =>
                  formData.manufacturerIds.includes(option.value)
                )}
                onChange={(event, newValue) => {
                  // Use custom handler logic here
                  const selectedManufacturerIds = newValue.map((item) => item.value);
                  const selectedManufacturerNames = newValue.map((item) => item.label);

                  const updatedData: Partial<StockCode> = { ...formData };
                  updatedData.manufacturerIds = selectedManufacturerIds;
                  updatedData.modelIDs = []; // Clear previously selected models

                  setFormData(updatedData as StockCode);

                  // Fetch models for selected manufacturers
                  selectedManufacturerIds.forEach((id: number) => {
                    getModelList(id);
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select one or more manufacturers"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />
            </FormControl>
          </Grid> */}



          {/* <Grid item xs={12} sm={6} md={3}>
            <h6>Select Manufacturers</h6>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                id="manufacturer"
                options={manufacturer} // manufacturer = array of { label: string, value: number }
                getOptionLabel={(option) => option.label}
                value={manufacturer.filter((option) =>
                  formData.manufacturerIds.includes(option.value)
                )}
                onChange={(event, newValue) => {
                  const selectedIds = newValue.map((item) => item.value);
                  setFormData((prev) => ({
                    ...prev,
                    manufacturerIds: selectedIds,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select one or more manufacturers"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />
            </FormControl>
          </Grid> */}

          <Grid item xs={12} sm={6} md={3}>
            <h6>Select Models</h6>
            <FormControl fullWidth>
              <Autocomplete
                multiple
                id="model"
                options={models} // models = array of { label: string, value: number }
                getOptionLabel={(option) => option.label}
                value={models.filter((option) =>
                  formData.modelIDs.includes(option.value)
                )}
                onChange={(event, newValue) => {
                  const selectedIds = newValue.map((item) => item.value);
                  setFormData((prev) => ({
                    ...prev,
                    modelIDs: selectedIds,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="Select one or more models"
                  />
                )}
                isOptionEqualToValue={(option, value) => option.value === value.value}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
          <h6>Current Stock</h6>
            <FormControl fullWidth>             
              <Input
                id="current_stock"                
                value={formData.current_stock}
                onChange={(e) => handleChange(e, "current_stock")}
              />
            </FormControl>
          </Grid>

          
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Currency</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select a Currency"
                id="insuranceCurrency"
                value={{
                  label: formData.insuranceCurrency ?? "", 
                  value: formData.insuranceCurrencyId?.toString() ?? "", 
                }}
                
                //value={{ label: formData.insuranceCurrencyId, value: formData.insuranceCurrency }}
                options={insuranceCurrency}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  // handleChange({ target: { value: newValue } }, "technique")
                  handleSelectCurrencyChange({ target: { value: newValue } }, "insuranceCurrency", "insuranceCurrencyId")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an insurance currency"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <h6>Select a Supplier</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select a Supplier"
                id="fromSupplier"
                value={{
                  label: formData.supplierName ?? "",
                  value: formData.supplierId?.toString() ?? "",
                }}
                options={suppliers}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) =>
                  handleSelectFromSupplierChange(event, newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard" // 👈 Match currency field style
                    placeholder="Select a supplier"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </FormControl>
          </Grid>

          
         
          <Grid item xs={12} sm={6} md={3}>
          <h6>Select a Unit</h6>
            <FormControl fullWidth>
              <Autocomplete
                aria-placeholder="Select an unit"
                id="unit"
                value={{
                  label: formData.unitName ?? "", 
                  value: formData.unitId?.toString() ?? "", 
                }}
                
                //value={{ label: formData.stockCodeId, value: formData.stockCode }}
                options={unit}
                getOptionLabel={(option) => option.label} // Assuming 'name' is a field in assetOwners array
                onChange={(event, newValue) =>
                  // handleChange({ target: { value: newValue } }, "technique")
                  handleSelectUnitsChange({ target: { value: newValue } })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="Select an unit"
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                } // Adjust according to your data structure
              />
            </FormControl>
          </Grid>

         
          <Grid item xs={12} sm={6} md={3}>
          <h6>Unit Price</h6>
            <FormControl fullWidth>             
              <Input
                id="unit_price"                
                value={formData.unit_price}
                onChange={(e) => handleChange(e, "unit_price")}
              />
            </FormControl>
          </Grid>

{/*          
          <Grid item xs={12} sm={6} md={3}>s
          <h6>Quantity</h6>
            <FormControl fullWidth>
          
              <Input
                id="quantity"
                value={formData.qty}
                onChange={(e) => handleChange(e, "quantity")}
                required
                type="number"
              />
            </FormControl>
          </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
          <h6>Date</h6>
            <FormControl fullWidth>
              <Calendar
                id="date"
                className="bg-white h-29"
                value={
                  formData.date ? new Date(formData.date) : null
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    date: e.value as Date | any,
                  })
                }
                showIcon
                dateFormat="mm/dd/yy"
                placeholder="Date"
                required
              />
            </FormControl>
          </Grid>
        
          <Grid item xs={12} sm={6} md={3}>
            <TakeCamera />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "end", marginTop: 2 }}
            >
              <Button severity="secondary" onClick={handleClear}>
                Cancel
              </Button>
               {userDetails.role.some(
                r => r.roleName === "Admin" || r.roleName === "Country View Write"
              ) && (
                <Button
                  severity="info"
                  onClick={handleSubmit}
                  color="primary"
                  style={{ marginLeft: 2 }}
                >
                  Save
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CreateStockCode;
